var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500Error(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364.382,
    height: 308,
    viewBox: "0 0 364.382 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ededed;}.b,.q{fill:#d8606e;}.c{fill:#e28693;}.d{fill:#edccd4;}.e{fill:#cc5269;}.f{fill:#db7286;}.g{fill:#1f159e;}.h{fill:#100e87;}.i{fill:#361cb7;}.j{fill:#c14d5e;}.k{fill:#fcdfd0;}.l{fill:#e2b5c2;}.m{fill:#e8baa6;}.n{fill:#090b33;}.o{fill:#adadea;}.p{fill:#8686e0;}.q{opacity:0.42;}.r{fill:#f2dde3;}.s{fill:#6158d6;}.t{fill:#cc485b;}.u{fill:#c1c1c1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-903.712 -352.905)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1170.215,997.169s-55.492,4.2-58.56-1.1,31.232-6.877,20.078-9.155-199.047-6.461-168.932,17.8c13.347,10.753,6.972,10.643-14.221,9.528s-78.973,6.111-17.066,20.461,105.129,20.763,88.676,25.5-12.828,31.518,38.482,24.682,202.171-29.689,196.315-35.133-51.867-5.914-26.77-13.626-17.847-18.588-34.578-17.751S1170.215,997.169,1170.215,997.169Z",
    transform: "translate(0 -426.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1410.74,1197.677l26.01,27.78,65.381-10.247-.058-2.23-29.969-22.656-61.422,5.123Z",
    transform: "translate(-341.778 -564.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1410.683,1190.833l26.01,27.78,65.381-10.247-30.027-24.886Z",
    transform: "translate(-341.778 -559.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1409.757,1155.074l-.447-17.283,61.365-7.353,25.853,25.541-.449,17.424-60.31,9.452Z",
    transform: "translate(-340.852 -524.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1702.614,943.895l4.4,29.682L1743.1,995.6l3.235-.554-10.2-35.071Z",
    transform: "translate(-538.585 -398.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1595.423,1045.248l-53.541,1.673v2.789l40.992,28.443,55.663-12.27-.56-2.506Z",
    transform: "translate(-430.227 -466.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1701.59,352.9V592.164L1563.277,525.8V412.022Z",
    transform: "translate(-444.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1987.754,352.9h5.02s6.135,67.483,6.135,119.629-7.064,118.143-7.064,118.143l-4.09,1.487Z",
    transform: "translate(-730.814 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1701.59,858.173v51.31l-138.313-66.368V823.6Z",
    transform: "translate(-444.65 -317.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1574.151,546.394V455.159L1698.882,411.1V577.577Z",
    transform: "translate(-451.981 -39.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1736.41,996.752l-21.829-11.924a.1.1,0,0,0-.028-.011h-.005v-.005l-17.457-9.531-4.4-29.682,17.111,8.21v.005l16.4,7.869Z",
    transform: "translate(-531.896 -399.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1595.423,1036.69l-53.541,4.462,40.992,28.443,51.867-11.433Z",
    transform: "translate(-430.227 -460.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1409.367,1144.635l26.01,27.78,65.381-10.247-.058-2.23-29.969-22.656-61.422,5.123Z",
    transform: "translate(-340.852 -528.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1409.31,1137.791l26.01,27.78,65.381-10.247-30.027-24.886Z",
    transform: "translate(-340.852 -524.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1653.237,1225.229l-11.226,1.1,11.226-2.789Z",
    transform: "translate(-497.729 -586.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1638.554,1236.666l-13.3,1.532,8.97.186-13.9,2.6,18.142-1.16Z",
    transform: "translate(-483.113 -595.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1755.08,995.065c2.755-8.17-9.582-23.881-9.877-24.255l16.4,7.869,10.207,35.069-21.829-11.924C1750.267,1001.969,1752.481,1002.778,1755.08,995.065Z",
    transform: "translate(-567.297 -416.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1370.292,992.639s-3.9,5.906-3.485,7.2,10.875,1.008,10.875,1.008l-3.9-10.227Z",
    transform: "translate(-312.177 -429.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1424.3,997.223s-3.346,6.249-2.51,7.23,8.784.748,9.2,0-3.207-8.526-3.207-8.526Z",
    transform: "translate(-349.177 -433.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1407.939,840.632a7.457,7.457,0,0,1-9.37,0s-2.008-10.491-3.564-18.739c-.87-4.612-1.589-8.517-1.74-9.5-.418-2.733-3.91-20.658-3.91-20.658l-.781-10.373-1.166-15.494,15.058-1.154a20.534,20.534,0,0,1,2.85,4.685c1.043,2.515.218,10.875.218,10.875s0,25.063-.139,26.937S1407.939,840.632,1407.939,840.632Z",
    transform: "translate(-326.088 -277.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1397.418,852.068c-.87-4.612-1.59-8.517-1.74-9.5-.418-2.733-3.91-20.658-3.91-20.658l-.781-10.373c2.069-1.116,3.854-2.064,3.854-2.064s1.394,4.74,0,8.784S1397.418,852.068,1397.418,852.068Z",
    transform: "translate(-328.5 -307.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1356.8,852.724s6.971,1.3,8.505-1.152c0,0-1.94-27.815-1.94-31.416s2.776-20.585,2.776-21.017,1.534-2.881,1.534-4.177-.7-13.108-.7-13.108-15.058-.506-15.337,1.62-1.285,32.192-.837,35.65S1356.8,852.724,1356.8,852.724Z",
    transform: "translate(-301.333 -289.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1440.958,695.238s3.021-9.74,3.509-11.756-4.566-10.012-5.188-10.411-2.365-16.006-.97-16.222,15.546,24.2,15.267,26.649-10.248,17.466-10.248,17.466Z",
    transform: "translate(-360.047 -204.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1374.922,692.19c-.686.446-14.149,2.013-23.179,2.571-4.484.279-7.869.307-8.053-.173-.4-1.032-2.013-22.5-2.459-34.93-.184-4.874-.184-8.354.14-8.667.808-.786,11.405-.5,19.771.073s11.645,1.01,11.991,1.511S1375.948,691.515,1374.922,692.19Z",
    transform: "translate(-294.872 -200.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1354.527,703.447s-1.037.446-2.526,1.082c-4.484.279-7.869.307-8.053-.173-.4-1.032-2.013-22.5-2.459-34.93.9-2.671,1.484-4.428,1.484-4.428s-.229,14.869,1.444,16.079,1.952,6.319.463,7.618S1345.793,702.17,1354.527,703.447Z",
    transform: "translate(-295.13 -210.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1211.543,596.031s8.087-1.441,9.481-1.056,6.693,6.05,6.879,6.818-3.718,2.378-3.9,2.437-1.3-2.245-2.045-2.245-3.253.192-3.439-.1,2.974-1.152,3.16-1.92-2.138-1.825-2.788-2.3S1211.543,597.567,1211.543,596.031Z",
    transform: "translate(-207.526 -163.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1244.063,615.744s5.949-4.359,6.6-3.687a15.729,15.729,0,0,1,1.58,3.686s-5.763,4-6.507,3.087A17.759,17.759,0,0,1,1244.063,615.744Z",
    transform: "translate(-229.45 -174.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1250.91,626.737s10.039,16.043,12.827,16.427,16.79.962,16.79.962,3.1-9.317.034-11.333c0,0-14.222,1.055-14.686.864s-9.016-10.142-9.016-10.142S1252.4,625.386,1250.91,626.737Z",
    transform: "translate(-234.066 -182.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1348.742,780.825s-.677,3.494.893,4.652l30.339-7.053S1352.135,780.344,1348.742,780.825Z",
    transform: "translate(-299.922 -286.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1432.34,779.524s.069,6.967,3.137,7.9l2.752-3.457-1.8-5.546A13.112,13.112,0,0,0,1432.34,779.524Z",
    transform: "translate(-356.378 -286.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1442.378,776.106s2.3,3.836,1.608,6.6a3.392,3.392,0,0,0,2.441-2.314s-.906-5.726-2.37-5.726A1.7,1.7,0,0,0,1442.378,776.106Z",
    transform: "translate(-363.145 -284.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1390.277,621.6a2.041,2.041,0,0,0-1.339,2.024v3.4l-8.477-.407,2.671-12.638h5.416l.686,3.023Z",
    transform: "translate(-321.404 -176.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1398.988,627.853a2.041,2.041,0,0,0-1.339,2.024v1.328c-1.054.19-1.846.3-1.846.3s1.143-2.75,0-3.653-2.421-4.244-2.421-4.244l4.562-.357Z",
    transform: "translate(-330.115 -182.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1375.782,642.681s-.226-4.48.323-4.48,10.827.405,10.984,1.216a31.391,31.391,0,0,1,0,3.891S1382.451,645.68,1375.782,642.681Z",
    transform: "translate(-318.218 -192.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1397.061,580.517s0,7.781-1.647,10.294-3.217,4.377-4.315,4.3-5.492-3.566-6.2-5.106a16.19,16.19,0,0,0-3.217-3.729s.392-7.7.942-7.781,13.259-3.809,13.259-3.809A19.31,19.31,0,0,1,1397.061,580.517Z",
    transform: "translate(-322.228 -149.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1398.071,587.033s5.618.18,7.267-2.134.277-3.43-.188-3.36-9.388.628-9.644.906S1398.071,587.033,1398.071,587.033Z",
    transform: "translate(-331.535 -154.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1375.3,572.03s.078-2.108-1.255-2.026-.862,5.187.628,5.187l-1.82,2.689s-6.418-10.551-6.339-12.091,3.766-8.511,4.942-8.673,2.354-2.918,2.981-2.837.314,1.621.314,1.621,10.67-.243,12.945,2.513-1.026,12.079-1,11.761-1.193-5.357-1.664-5.438c0,0-4.137,4.221-7.524,3.972C1375.3,568.545,1375.3,572.03,1375.3,572.03Z",
    transform: "translate(-312.001 -135.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1388.622,606.027a1.3,1.3,0,0,1,1.139,1.458A2.689,2.689,0,0,0,1388.622,606.027Z",
    transform: "translate(-326.905 -170.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1171.949,751.806v84.059h-8.382v-84.17l4.573-2.554Z",
    transform: "translate(-175.183 -267.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1121.632,592.334a27.049,27.049,0,1,0,27.049,27.049A27.049,27.049,0,0,0,1121.632,592.334Zm0,48.707a21.658,21.658,0,1,1,21.658-21.658A21.658,21.658,0,0,1,1121.632,641.041Z",
    transform: "translate(-128.677 -161.413)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 21.658,
    cy: 21.658,
    r: 21.658,
    transform: "translate(971.297 436.312)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 8.382,
    height: 5.019,
    transform: "translate(988.384 549.22)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1002.381 443.757)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1210.389,654.2h0a1.947,1.947,0,0,1-.383-2.546c2.225-3.433,2.355-7.3.381-11.524a23.081,23.081,0,0,0-3.393-5.16,1.948,1.948,0,0,1,.054-2.6l.017-.018a1.958,1.958,0,0,1,2.9.042c4.154,4.7,8.552,13.345,3.3,21.406A1.946,1.946,0,0,1,1210.389,654.2Z",
    transform: "translate(-1206.523 -631.726)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1108.579,1086.246c-.445.648-.716,1.031-.716,1.031s-.014-.266-.011-.73c-.009-2.7.346-12.022,5.612-13.8C1118.7,1070.989,1111.031,1082.652,1108.579,1086.246Z",
    transform: "translate(-137.622 -485.166)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1096.71,1087.013c-.048.466-.084.785-.08.892,0,0-.179-.278-.465-.756-1.82-3-8.067-13.85-3.092-13.645C1098.1,1073.712,1097.043,1083.847,1096.71,1087.013Z",
    transform: "translate(-126.388 -485.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1102.089,1094.053c-.048.466-.084.785-.08.892,0,0-.179-.278-.465-.756l-2.376-10.245Z",
    transform: "translate(-131.767 -492.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1112.792,1081.858l-4.212,10.651c-.445.648-.716,1.031-.716,1.031s-.014-.266-.011-.731Z",
    transform: "translate(-137.622 -491.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1104.264,1116s-2.375-.018-1.471.6,3.883.293,3.078-.094A4.866,4.866,0,0,0,1104.264,1116Z",
    transform: "translate(-134.074 -514.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1319.119,1201.375c-.445.648-.716,1.03-.716,1.03s-.014-.266-.011-.731c-.009-2.7.346-12.022,5.612-13.8C1329.236,1186.118,1321.57,1197.781,1319.119,1201.375Z",
    transform: "translate(-279.559 -562.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1307.249,1202.142c-.048.466-.084.784-.08.892,0,0-.179-.278-.465-.756-1.82-3-8.068-13.85-3.092-13.645C1308.638,1188.841,1307.583,1198.976,1307.249,1202.142Z",
    transform: "translate(-268.325 -563.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1312.629,1209.183c-.048.466-.084.784-.08.892,0,0-.179-.278-.465-.756l-2.376-10.245Z",
    transform: "translate(-273.704 -570.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1323.331,1196.987l-4.212,10.651c-.445.648-.716,1.03-.716,1.03s-.014-.266-.011-.731Z",
    transform: "translate(-279.559 -569.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1314.8,1231.132s-2.375-.018-1.471.6,3.884.293,3.078-.094A4.865,4.865,0,0,0,1314.8,1231.132Z",
    transform: "translate(-276.01 -592.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1864.55,1159.91c-.445.648-.716,1.03-.716,1.03s-.014-.266-.011-.731c-.009-2.7.345-12.022,5.612-13.8C1874.666,1144.653,1867,1156.316,1864.55,1159.91Z",
    transform: "translate(-647.265 -534.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1852.679,1160.677c-.048.466-.084.784-.08.892,0,0-.178-.278-.465-.756-1.82-3-8.067-13.85-3.092-13.645C1854.068,1147.376,1853.013,1157.511,1852.679,1160.677Z",
    transform: "translate(-636.031 -535.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1858.058,1167.718c-.048.466-.084.784-.08.892,0,0-.179-.278-.465-.756l-2.376-10.245Z",
    transform: "translate(-641.41 -542.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1868.762,1155.523l-4.212,10.651c-.445.648-.716,1.03-.716,1.03s-.014-.266-.011-.731Z",
    transform: "translate(-647.265 -541.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M1860.234,1189.668s-2.375-.018-1.471.6,3.883.294,3.078-.094A4.858,4.858,0,0,0,1860.234,1189.668Z",
    transform: "translate(-643.716 -564.11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1153.637 483.589)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1705.273,760.424l-33.11-3.086a1.665,1.665,0,0,1-1.44-1.779h0a1.6,1.6,0,0,1,1.6-1.587l33.2,1.177a1.657,1.657,0,0,1,1.523,1.785l-.09,1.909A1.593,1.593,0,0,1,1705.273,760.424Z",
    transform: "translate(-1670.722 -753.971)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1136.618 440.561)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.379,
    height: 32.085,
    rx: 2.689,
    transform: "translate(0 1.972) rotate(-21.511)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1135.267 439.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 32.092,
    height: 5.378,
    rx: 2.689,
    transform: "matrix(0.458, -0.889, 0.889, 0.458, 0, 28.534)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1191.809 433.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.378,
    height: 45.993,
    rx: 2.689,
    transform: "translate(0 2.366) rotate(-26.101)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1191.946 431.76)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1789.758,636.436h0a2.984,2.984,0,0,1-1.17-3.878L1805.8,596.48a2.606,2.606,0,0,1,3.618-1.254h0a2.984,2.984,0,0,1,1.17,3.879l-17.211,36.078A2.606,2.606,0,0,1,1789.758,636.436Z",
    transform: "translate(-1788.292 -594.909)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Error);
export default __webpack_public_path__ + "static/media/500Error.4f4c2aef7ce70a439cb4857349879439.svg";
export { ForwardRef as ReactComponent };